import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const initialValues = { isModalOpen: false, openYachtModal: () => {}, close: () => {}, yachtData: null };
export const YachtModalContext = createContext(initialValues);

export const YachtModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [yachtData, setYachtData] = useState(null);

  const openYachtModal = yachtData => {
    setYachtData(yachtData);
    setIsModalOpen(true);
  };

  const close = () => {
    setIsModalOpen(false);
    setYachtData(null);
  };

  return (
    <YachtModalContext.Provider value={{ isModalOpen, openYachtModal, close, yachtData }}>
      {children}
    </YachtModalContext.Provider>
  );
};
YachtModalProvider.propTypes = { children: PropTypes.any };

export const useYachtModal = () => useContext(YachtModalContext);

export const withYachtModal = WrappedComponent => {
  return function YachtModalComponent(props) {
    return (
      <YachtModalContext.Consumer>
        {context => <WrappedComponent {...props} yachtModalContext={context} />}
      </YachtModalContext.Consumer>
    );
  };
};
